interface ListSkeletonProps {
  count?: number;
}

export function ListSkeleton({ count = 5 }: ListSkeletonProps = {}) {
  return (
    <ul className="space-y-2">
      {Array.from({ length: count }).map((_, i) => (
        <li
          key={i}
          className="h-[122px] animate-pulse rounded-xl border border-border bg-surface"
        />
      ))}
    </ul>
  );
}
